import React from 'react';
import Card from '../../../core/layout/Card';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import PlacementTestItemsListContainer from './PlacementTestItemsListContainer';
import PlacementTestItemsListFilterContainer from './PlacementTestItemsListFilterContainer';

const PlacementTestItemsListScene = () => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Placement Test Items History',
        },
      ]}
    />
    <Card title="Placement Test Items History">
      <PlacementTestItemsListFilterContainer />
      <PlacementTestItemsListContainer />
    </Card>
  </div>
);

export default PlacementTestItemsListScene;
